// extracted by mini-css-extract-plugin
export var content = "_4h-3";
export var list = "_4h-4";
export var settingsContent = "_4h-7";
export var settingsPanel = "_4h-8";
export var state = "_4h-6";
export var triggerBadge = "_4h-2";
export var triggerButton = "_4h-1";
export var triggerShell = "_4h-0";
export var unreadDot = "_4h-5";